import { Color } from "../core/util/Color";
import { Theme } from "../core/Theme";

/**
 * @ignore
 */
export class SeabornTheme extends Theme {
	protected setupDefaultRules() {
		super.setupDefaultRules();

		this.rule("ColorSet").setAll({
			colors: [
				Color.fromHex(0x4C72B0),
				Color.fromHex(0xDD8452),
				Color.fromHex(0x5AAA95),
				Color.fromHex(0x55A868),
				Color.fromHex(0x8172B3),
				Color.fromHex(0x937860),
				Color.fromHex(0xDA8bc3),
				Color.fromHex(0x8C8C8C),
				Color.fromHex(0xCCB974),
				Color.fromHex(0x64B5CD)
			],
			reuse: true
		});
	}
}
